<template>
  <nav 
    class="navbar navbar-expand-lg navbar-light fixed-top" 
    id="mainNav" 
    :class="{
      scrolling: scrollPosition > 0,
      'menu-open': isMenuOpen
    }"
  >
    <div class="container">
      <NavBrand 
        :is-scrolled="scrollPosition > 0"
        @close="closeMenu"
      />
      
      <NavToggle 
        :is-open="isMenuOpen"
        :is-scrolled="scrollPosition > 0"
        @toggle="toggleMenu"
      />
      
      <NavMenu 
        :is-open="isMenuOpen"
        :is-desktop="windowWidth >= 992"
      >
        <template #pages>
          <NavLink 
            v-if="isHomePage"
            to="/contattaci"
            label="Contattaci"
            @click="handleNavClick()"
          />
          <NavLink 
            v-else
            to="/"
            label="Home"
            @click="handleNavClick()"
          />
        </template>
        
        <template #actions>
          <NavAction 
            label="Download"
            href="#download"
            icon="fas fa-download"
            variant="primary"
            @click="handleNavClick(() => scrollToSection('#download'))"
          />
          <NavAction 
            label="Sito ufficiale"
            href="https://www.lotteriadegliscontrini.gov.it"
            icon="fas fa-external-link-alt"
            variant="outline"
            @click="handleNavClick()"
          />
          <NavAction 
            label="Scarica locandina"
            href="/files/Locandina.pdf"
            icon="fas fa-file-pdf"
            variant="secondary"
            @click="handleNavClick()"
          />
        </template>
      </NavMenu>
    </div>
  </nav>
</template>

<script>
import NavBrand from './navbar/NavBrand.vue'
import NavToggle from './navbar/NavToggle.vue'
import NavLink from './navbar/NavLink.vue'
import NavAction from './navbar/NavAction.vue'
import NavMenu from './navbar/NavMenu.vue'

export default {
  name: 'Navbar',
  components: {
    NavBrand,
    NavToggle,
    NavLink,
    NavAction,
    NavMenu
  },
  props: {
    scrollPosition: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isMenuOpen: false,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 992
    }
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/' || this.$route.path === ''
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMenu() {
      this.isMenuOpen = false
      document.body.style.overflow = ''
    },
    handleResize() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth >= 992) {
        this.closeMenu()
      }
    },
    handleNavClick(callback) {
      if (callback) {
        callback()
      }
      this.closeMenu()
    },
    scrollToSection(hash) {
      if (this.$route.path === '/') {
        const element = document.querySelector(hash)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        this.$router.push({ path: '/', hash }).then(() => {
          setTimeout(() => {
            const element = document.querySelector(hash)
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' })
            }
          }, 100)
        })
      }
    }
  }
}
</script>

<style scoped>
#mainNav {
  padding: 1.25rem 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);
  z-index: 1000;
  border-bottom: 1px solid transparent;
}

#mainNav .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

#mainNav.scrolling {
  background: linear-gradient(135deg, rgba(42, 82, 152, 0.95), rgba(30, 60, 114, 0.95));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.1);
  padding: 0.875rem 0;
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

/* Desktop styles */
@media (min-width: 992px) {
  #mainNav {
    background-color: transparent;
    padding: 1.75rem 0;
  }

  #mainNav.scrolling {
    padding: 1rem 0;
  }
}

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}
</style>

